import React from 'react';
import * as d3 from 'd3';
import '../css/Bar.css';


export default class BarChart extends React.Component {
	constructor(props) {
      super(props)
      
      this.state = {
        usData: null,
      }
      this.anchor = React.createRef();
    }

    componentDidMount() {
    	this.setBar2();
    }

    componentDidUpdate() {
    	this.updateAvgDelay2();
    }

    updateAvgDelay2() {
    	var data = this.props.avgDelay;
    	data.sort(function(a, b) { return a.AvgTotal - b.AvgTotal; });	

    	const keys = ["avgArrivalDelay", "avgDepartureDelay"];
    	const colors = ["#98abc5", "#a05d56"];

	 	var getRatio = (side, margin) => {
      		return (( margin[side] / width ) * 100 + 1) + "%";
 		}

	    var margin = {left: 40, top: 10, right: 10, bottom: 20},
	    	width = 600 - margin.left - margin.right,
	      	height = 300 - margin.top - margin.bottom,
	      	marginRatio = {
	        	left: getRatio("left", margin),
	          	top: getRatio("top", margin),
	          	right: getRatio("right", margin),
	          	bottom: getRatio("bottom", margin)
	      	};

    	const g = d3.select("#svg-g");

    	var x = d3.scaleBand()
      		.rangeRound([margin.left, width - margin.right])
      		.padding(0.2);

			
		var y = d3.scaleLinear()
			.rangeRound([height - margin.bottom, margin.top])

		var z = d3.scaleOrdinal()
		.range(colors)
		.domain(keys);

		
		x.domain(data.map((d) => { return d._id;}));


		g.select(".xaxis")
			.attr("transform", `translate(0,${height - margin.bottom})`)
			.transition()
			.call(d3.axisBottom(x))


		y.domain([-1, 
			d3.max(data, d => {return d.AvgTotal}) + 5])
      	g.select(".yaxis")
      		.transition()
			.call(d3.axisLeft(y))
			// .append("text")
			// .attr("x", 2)
			// .attr("y", y(y.ticks().pop()) + 0.5)
			// .attr("dy", "0.32em")
			// .attr("fill", "#000")
			// .attr("font-weight", "bold")
			// .attr("text-anchor", "start")
			// .text("min");

		z.domain(keys);

		const stack_g = g.select(".zaxis")
						.selectAll("g")
						.data(d3.stack().keys(keys)(data), (d) => {return d})
						

    	// d3.selectAll(".bar").remove();
    	var t = d3.transition()
      			.duration(400);

      	var tooltip = d3.select("#barTooltip")
      					.style("z-index", "999")

		// EXIT old elements not present in new data.
		stack_g.exit()
			.attr("class", "exit")
			.transition(t)
			.attr("y", 20)
      		.style("fill-opacity", 1e-6)
		  	.remove();

		// UPDATE old elements present in new data.
		stack_g.attr("class", "update")
			// .attr("class", "bar")
			.selectAll("rect")
			.data((d) => {return d})
			.enter()
			.transition(t)
			.attr("x", function(d) { return x(d.data._id); })
			.attr("y", function(d) { return y(d[1]); })
			.attr("height", function(d) { return y(d[0]) - y(d[1]); })
			.attr("width", x.bandwidth())
			

		// ENTER new elements present in new data.
		stack_g.enter().append("g")
			.attr("fill", function(d) { return z(d.key); })
			.attr("class", "enter")
			// .attr("class", "bar")
			// .attr("fill", function(d) { return z(d.key); })
			.selectAll("rect")
			.data((d) => {return d})
			.enter().append('rect')
			.transition(t)
			.attr("x", function(d) { return x(d.data._id); })
			.attr("y", function(d) { return y(d[1]); })
			.attr("height", function(d) { return y(d[0]) - y(d[1]); })
			.attr("width", x.bandwidth())


			d3.selectAll("rect")
			.on("mousemove", function(){ 
				d3.select(this).style("stroke", "black")
				return tooltip.style("top",(d3.event.pageY-40)+"px")
							.style("left",(d3.event.pageX+10)+"px");
			}).on("mouseout", function() { 
				d3.select(this).style("stroke", "");
      			return tooltip.style("visibility", "hidden"); 
      		})
			.on("mouseover", function(d) {
		      tooltip.text((d[1] - d[0]).toFixed(1));
		      return tooltip.style("visibility", "visible");
		    })
		    .on('click', d => {
						this.props.onClickAirline(d.data._id);
					})

		
    }

    updateAvgDelay() {
    	var getRatio = (side, margin) => {
      		return (( margin[side] / width ) * 100 + 1) + "%";
 		}

	    var margin = {left: 40, top: 10, right: 10, bottom: 20},
	    	width = 400 - margin.left - margin.right,
	      	height = 250 - margin.top - margin.bottom,
	      	marginRatio = {
	        	left: getRatio("left", margin),
	          	top: getRatio("top", margin),
	          	right: getRatio("right", margin),
	          	bottom: getRatio("bottom", margin)
	      	};

    	const data = this.props.avgDelay;
    	console.log(data);

    	const g = d3.select("#svg-g");

		var x = d3.scaleBand()
      		.rangeRound([0, width])
      		.padding(0.2);

		var y = d3.scaleLinear()
			.rangeRound([height, 0])
		
		x.domain(data.map((d) => { return d._id;}));


		g.select(".xaxis")
			.attr("transform", "translate(0," + height + ")")
			.transition()
			.call(d3.axisBottom(x))


		y.domain([
			d3.min(data, function (d) {
			return Number(d.avgArrivalDelay);
		}) - 2, 
			d3.max(data, function (d) {
			return Number(d.avgArrivalDelay);
		}) + 2]);

      	g.select(".yaxis")
      		.transition()
			.call(d3.axisLeft(y));

    	// d3.selectAll(".bar").remove();
    	var t = d3.transition()
      			.duration(400);

    	const bars = g.selectAll("rect")
						.data(data, (d) => {console.log(d);return d});

		// EXIT old elements not present in new data.
		bars.exit()
			.attr("class", "exit")
			.attr("class", "bar")
			.transition(t)
			.attr("y", 60)
      		.style("fill-opacity", 1e-6)
		  	.remove();

		// UPDATE old elements present in new data.
		bars.attr("class", "update")
			.attr("class", "bar")
			.transition(t)
			.attr("x", function (d) {
				return x(d._id);
			})
			.attr("y", function (d) {
				return y(Number(d.avgArrivalDelay));
			})
			.attr("width", x.bandwidth())
			.attr("height", function (d) {
				return height - y(Number(d.avgArrivalDelay));
			});

		// ENTER new elements present in new data.
		bars.enter().append("rect")
			.attr("class", "enter")
			.attr("class", "bar")
			.transition(t)
			.attr("x", function (d) {
				return x(d._id);
			})
			.attr("y", function (d) {
				return y(Number(d.avgArrivalDelay));
			})
			.attr("width", x.bandwidth())
			.attr("height", function (d) {
				return height - y(Number(d.avgArrivalDelay));
			});	

		// bars.enter().append("rect")
		// .attr("class", "bar")

		// bars.transition()
	 //        .duration(400)
		// 	.attr("x", function (d) {
		// 		return x(d._id);
		// 	})
		// 	.attr("y", function (d) {
		// 		return y(Number(d.avgArrivalDelay));
		// 	})
		// 	.attr("width", x.bandwidth())
		// 	.attr("height", function (d) {
		// 		console.log(height - y(Number(d.avgArrivalDelay)));
		// 		return height - y(Number(d.avgArrivalDelay));
		// 	});
		// bars.exit().remove();
    }

    setBar() {
    	const data = this.props.avgDelay;

	 	var getRatio = (side, margin) => {
      		return (( margin[side] / width ) * 100 + 1) + "%";
 		}

	    var margin = {left: 40, top: 10, right: 10, bottom: 20},
	    	width = 400 - margin.left - margin.right,
	      	height = 250 - margin.top - margin.bottom,
	      	marginRatio = {
	        	left: getRatio("left", margin),
	          	top: getRatio("top", margin),
	          	right: getRatio("right", margin),
	          	bottom: getRatio("bottom", margin)
	      	};

    	const svg = d3.select(this.anchor.current)
    				.append("svg")
    				.style("padding", marginRatio.top + " " + marginRatio.right + " " + marginRatio.bottom + " " + marginRatio.left)
					.attr("preserveAspectRatio", "xMinYMin meet")
					.attr("viewBox", "0 0 " + ( width + margin.left + margin.right  ) + " " + ( height + margin.top + margin.bottom ))
					.attr("id", "svg-bar")
					.attr("class", "graph-svg-placeholder");

		const g = svg.append("g")
					.attr("transform", "translate(" + margin.left + "," + margin.top + ")")
					.attr("id", "svg-g")
		g.append("g")
    		.classed("xaxis", true)

	    g.append("g")
	    	.classed("yaxis", true)

	    var x = d3.scaleBand()
      		.rangeRound([0, width])
      		.padding(0.2);

			
		var y = d3.scaleLinear()
			.rangeRound([height, 0])
		

		x.domain(data.map((d) => { return d._id;}));

		g.select(".xaxis")
			.attr("transform", "translate(0," + height + ")")
			.transition()
			.call(d3.axisBottom(x))


		y.domain([
			d3.min(data, function (d) {
			return Number(d.avgArrivalDelay);
		}) - 2, 
			d3.max(data, function (d) {
			return Number(d.avgArrivalDelay);
		}) + 2]);

      	g.select(".yaxis")
			.call(d3.axisLeft(y))
			.append("text")
			.attr("fill", "#000")
			.attr("transform", "rotate(-90)")
			.attr("y", 6)
			.attr("dy", "0.71em")
			.attr("text-anchor", "end")
			.text("Average Delay (min)");

	    const bars = g.selectAll(".bar")
						.data(this.props.avgDelay);
		
		bars.enter().append("rect")
		.attr("class", "bar")
		.attr("x", function (d) {
				return x(d._id);
			})
			.attr("y", function (d) {
				return y(Number(d.avgArrivalDelay));
			})
			.attr("width", x.bandwidth())
			.attr("height", function (d) {
				return height - y(Number(d.avgArrivalDelay));
			});
    }

    setBar2() {
    	var data = this.props.avgDelay;
    	data.sort(function(a, b) { return a.AvgTotal - b.AvgTotal; });
    	
    	const keys = ["avgArrivalDelay", "avgDepartureDelay"];

	 	var getRatio = (side, margin) => {
      		return (( margin[side] / width ) * 100 + 1) + "%";
 		}

	    var margin = {left: 40, top: 10, right: 10, bottom: 20},
	    	width = 600 - margin.left - margin.right,
	      	height = 300 - margin.top - margin.bottom,
	      	marginRatio = {
	        	left: getRatio("left", margin),
	          	top: getRatio("top", margin),
	          	right: getRatio("right", margin),
	          	bottom: getRatio("bottom", margin)
	      	};

    	const svg = d3.select(this.anchor.current)
    				.append("svg")
    				.style("padding", marginRatio.top + " " + marginRatio.right + " " + marginRatio.bottom + " " + marginRatio.left)
					.attr("preserveAspectRatio", "xMinYMin meet")
					.attr("viewBox", "0 0 " + ( width + margin.left + margin.right  ) + " " + ( height + margin.top + margin.bottom ))
					.attr("id", "svg-bar")
					.attr("class", "graph-svg-placeholder");

		const g = svg.append("g")
					.attr("transform", "translate(" + margin.left + "," + margin.top + ")")
					.attr("id", "svg-g")

		g.append("g")
    		.classed("xaxis", true)

	    g.append("g")
	    	.classed("yaxis", true)

	    g.append("g")
	    	.classed("zaxis", true)

	    var x = d3.scaleBand()
      		.rangeRound([margin.left, width - margin.right])
      		.padding(0.2);

			
		var y = d3.scaleLinear()
			.rangeRound([height - margin.bottom, margin.top])

		const colors = ["#98abc5", "#a05d56"];

		var z = d3.scaleOrdinal()
		.range(colors)
		.domain(keys);
		

		x.domain(data.map((d) => { return d._id;}));

		g.select(".xaxis")
			.attr("transform", `translate(0,${height - margin.bottom})`)
			.transition()
			.call(d3.axisBottom(x))


		y.domain([-1, 
			d3.max(data, d => {return d.AvgTotal}) + 5])
      	g.select(".yaxis")
			.call(d3.axisLeft(y))
			.append("text")
			.attr("x", 2)
			.attr("y", y(y.ticks().pop()) + 0.5)
			.attr("dy", "0.32em")
			.attr("fill", "#000")
			.attr("font-weight", "bold")
			.attr("text-anchor", "start")
			.text("min");

		z.domain(keys);
		const stack_g = g.select(".zaxis")
						.selectAll("g")
						.data(d3.stack().keys(keys)(data))
						.enter().append("g")
						.attr("fill", function(d) { return z(d.key); })

		const stack_rect = stack_g.selectAll("rect")
					.data(function(d) { return d; })
					.enter().append("rect")
					.attr("class", "bar")
					.attr("x", function(d) { return x(d.data._id); })
					.attr("y", function(d) { return y(d[1]); })
					.attr("height", function(d) { return y(d[0]) - y(d[1]); })
					.attr("width", x.bandwidth())
					.on('click', d => {
						this.props.onClickAirline(d.data._id);
					})
		
		var tooltip = d3.select("#barTooltip")

			stack_rect.on("mousemove", d => { 
				return tooltip.style("top",(d3.event.pageY-40)+"px")
							.style("left",(d3.event.pageX+10)+"px");
			}).on("mouseout", function() { 
				d3.select(this).style("stroke", "");
      			return tooltip.style("visibility", "hidden"); 
      		})
			.on("mouseover", function(d) {
			  d3.select(this).style("stroke", "black")
		      tooltip.text((d[1] - d[0]).toFixed(1));
		      return tooltip.style("visibility", "visible");
		    });

			

		var legend = g.append("g")
		.attr("font-family", "sans-serif")
		.attr("font-size", 10)
		.attr("text-anchor", "end")
		.selectAll("g")
		.data(keys.slice().reverse())
		.enter().append("g")
		.attr("transform", function(d, i) { return "translate(0," + i * 20 + ")"; });

		legend.append("rect")
		.attr("x", width - 19)
		.attr("width", 19)
		.attr("height", 19)
		.attr("fill", z);

		legend.append("text")
		.attr("x", width - 24)
		.attr("y", 9.5)
		.attr("dy", "0.32em")
		.text(function(d) { return d; });
    }

    render() {
    	return(
    		<React.Fragment>
    		<div ref={this.anchor} />
    		</React.Fragment>
    	);
    }
}